import { Link, NavLink } from "react-router-dom";

const Vachanalay = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6 text-left"> 
               वाचनालय
            </h1>
            <div className="h-0.5 w-full bg-orange-500 mb-6"></div>

            <p className="text-gray-700 mb-4 text-left">
                ग्रामपंचायत चांडोली खुर्द,ता.आंबेगाव,जि .पुणे  या ठिकाणी शासनमान्य वाचनालय असून त्यास सन २००० मध्ये   शासन मान्यता मिळाली आहे.वाचनालयाचा दर्जा इतर "ब" आहे . वाचनालयामध्ये एकूण पुस्तक संख्या १३७६९ असून त्यामध्ये धार्मिक ,शैक्षणिक, MPSC, UPSC अशा विविध स्पर्धा परीक्षांची पुस्तके उपलब्ध आहेत.वाचनालयात दररोज १० वर्तमानपत्र वाचकांसाठी उपलब्ध असतात.सदर वाचनालयात ३ कर्मचारी कार्यरत आहेत. 
            </p>

        </div>
    );
}


export default Vachanalay;